module.exports = __webpack_public_path__ + "img/home-mini.ac8f50e9.svg";